import { type Component, ControlProxy } from "../global";
import { computed, inject, watch, type Ref } from "vue";

export function useListItem() {
  const item = inject<Ref<Record<string, any> | undefined>>("item")!;
  const index = inject<Ref<number>>("index")!;
  const cmp = inject<Component>("component")!;
  const proxy = inject<ControlProxy>("proxy")!;
  const props = inject<Ref<Record<string, any>>>("props")!;
  watch(
    () => props.value[`key${index.value}${cmp.key}`],
    (extProps) => extProps && proxy.setProperties(extProps),
    { immediate: true }
  );

  const styles = inject<Ref<Record<string, any>>>("styles")!;
  const style = computed(() => styles.value[`key${index.value}${cmp.key}`]);
  return { item, index, style };
}
